import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface MigrationState {
  migratingUsers: Set<string>;
  migrationErrors: Map<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class UserMigrationStateService {
  private readonly state$ = new BehaviorSubject<MigrationState>({
    migratingUsers: new Set(),
    migrationErrors: new Map()
  });

  constructor() {}

  /**
   * Check if a user is currently being migrated
   */
  isMigrating(email: string): boolean {
    return this.state$.value.migratingUsers.has(email);
  }

  /**
   * Get migration error for a user if any
   */
  getMigrationError(email: string): string | undefined {
    return this.state$.value.migrationErrors.get(email);
  }

  /**
   * Set migrating state for a user
   */
  setMigrating(email: string, isMigrating: boolean): void {
    const state = this.state$.value;
    if (isMigrating) {
      state.migratingUsers.add(email);
      state.migrationErrors.delete(email);
    } else {
      state.migratingUsers.delete(email);
    }
    this.state$.next({ ...state });
  }

  /**
   * Set error for a user
   */
  setError(email: string, error: string): void {
    const state = this.state$.value;
    state.migratingUsers.delete(email);
    state.migrationErrors.set(email, error);
    this.state$.next({ ...state });
  }

  /**
   * Clear error for a specific user
   */
  clearError(email: string): void {
    const state = this.state$.value;
    state.migrationErrors.delete(email);
    this.state$.next({ ...state });
  }
}

